module.exports = __webpack_public_path__ + "img/tiles-bg.bdd2a859.png";